export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["加密ID: "])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["语言"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["早上好"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["下午好"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["晚上好"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["晚安"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["退出"])}
}